import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IconButtonComponent, TooltipDirective } from '@mode/capra';
import { FeatureFlag, FeatureFlagsFacade } from '@mode/shared/contract-common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ScheduleModalFacade } from '@mode/shared/schedules/contract';

@Component({
  selector: 'mode-named-schedule-header',
  standalone: true,
  imports: [CommonModule, IconButtonComponent, TooltipDirective, ReactiveFormsModule],
  templateUrl: './named-schedule-header.component.html',
  styleUrls: ['./named-schedule-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NamedScheduleHeaderComponent implements OnInit {
  @Input() schedule: any;
  @ViewChild('scheduleName') scheduleNameRef: ElementRef | undefined;
  public ShowNamedSchedules: boolean | undefined;
  public isScheduleNameEditMode = false;
  public showNamedSchedules = true;
  public form: FormGroup;

  constructor(private featureFlagsFacade: FeatureFlagsFacade, public scheduleModalFacade: ScheduleModalFacade) {
    this.form = new FormGroup({});
    this.featureFlagsFacade.asObservable(FeatureFlag.ShowNamedSchedules).subscribe((enabled) => {
      this.ShowNamedSchedules = enabled;
    });
  }
  ngAfterViewInit(): void {
    // Use AfterViewInit to ensure the view is fully initialized
    if (this.isScheduleNameEditMode) {
      this.fousScheduleNameInput();
    }
  }

  ngOnInit(): void {
    if (this.schedule._new_reportSchedule) {
      this.isScheduleNameEditMode = true;
    }
    this.featureFlagsFacade.asObservable(FeatureFlag.ShowNamedSchedules).subscribe((flag) => {
      this.showNamedSchedules = flag;
      this.form = new FormGroup({
        name: new FormControl(this.schedule.name || '', {
          validators: [Validators.minLength(4), Validators.maxLength(64)],
          updateOn: 'blur',
        }),
      });
      this.form.get('name')?.valueChanges.subscribe((value) => {
        this.schedule.name = value;
      });
    });
  }

  fousScheduleNameInput() {
    this.scheduleNameRef?.nativeElement.focus();
  }

  editScheduleName() {
    this.isScheduleNameEditMode = !this.isScheduleNameEditMode;
    // the element is not present in the DOM when not in edit mode
    // so when we load the input, give some breathing space so it never fails
    // to find the scheduleNameRef element in DOM
    setTimeout(() => {
      this.fousScheduleNameInput();
    }, 10);
  }
  handleDoubleClick() {
    this.isScheduleNameEditMode = true;
    setTimeout(() => {
      this.fousScheduleNameInput();
    }, 10);
  }
  focusOutFunction() {
    this.isScheduleNameEditMode = false;
    if (this.schedule.name.length == 0) {
      this.schedule.name = 'Untitled schedule';
      this.scheduleModalFacade.onScheduleNameChange(this.schedule.name);
      return;
    }
    if (this.form.get('name')?.invalid) {
      this.isScheduleNameEditMode = true;
      this.fousScheduleNameInput();
      return;
    }
    this.scheduleModalFacade.onScheduleNameChange(this.schedule.name);
  }
}
